<script>
export default {
  name: 'WorkOrderScheduleCrewTab',
  props: {
    installDuration: {
      type: [String, Number],
      default: '2 h',
    },
    city: {
      type: [String, Number],
      default: 'Medan',
    },
    planDatetime: {
      type: [String, Date],
      default: '',
    },
    isConfirmed: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        installDate: '',
        startTime: '',
        isConfirmed: false,
      },
    }
  },
  computed: {
    canSaveSchedule() {
      return Boolean(this.form.installDate && this.form.startTime && !this.loading)
    },
  },
  watch: {
    planDatetime() {
      this.setForm()
    },
    isConfirmed() {
      this.setForm()
    },
  },
  created() {
    this.setForm()
  },
  methods: {
    setForm() {
      const date = this.parsePlanDatetime()

      this.form = {
        installDate: date ? this.formatDateInput(date) : '',
        startTime: date ? `${this.padTimePart(date.getHours())}:${this.padTimePart(date.getMinutes())}` : '',
        isConfirmed: this.isConfirmed,
      }
    },
    parsePlanDatetime() {
      if (!this.planDatetime) return null

      const date = new Date(this.planDatetime)

      if (Number.isNaN(date.getTime())) return null

      return date
    },
    formatDateInput(date) {
      return [
        date.getFullYear(),
        this.padTimePart(date.getMonth() + 1),
        this.padTimePart(date.getDate()),
      ].join('-')
    },
    padTimePart(value) {
      return String(value).padStart(2, '0')
    },
    submitSchedule() {
      if (!this.canSaveSchedule) return

      const planDate = new Date(`${this.form.installDate}T${this.form.startTime}:00`)
      if (Number.isNaN(planDate.getTime())) return

      this.$emit('update-schedule', {
        plan_datetime: planDate.toISOString(),
        is_plan_confirmed: this.form.isConfirmed,
      })
    },
  },
}
</script>

<template>
  <article class="wo-panel wo-schedule-panel">
    <div class="wo-panel__header">
      <h2>Schedule</h2>
      <p>
        Slot length follows the WO: {{ installDuration }}. Any start time from 00:00 is allowed, as long as the slot ends by 24:00.
      </p>
    </div>

    <div class="wo-schedule-grid">
      <div class="wo-schedule-field">
        <label>INSTALL DATE</label>
        <input
          v-model="form.installDate"
          type="date"
          class="wo-select-field"
          :disabled="loading"
        />
      </div>

      <div class="wo-schedule-field">
        <label>START TIME</label>
        <input
          v-model="form.startTime"
          type="time"
          class="wo-select-field"
          :disabled="loading"
        />
      </div>

      <div class="wo-schedule-field wo-schedule-field--checkbox">
        <label>CUSTOMER</label>
        <label class="wo-checkbox-row">
          <input v-model="form.isConfirmed" type="checkbox" :disabled="loading" />
          <span>Confirmed the date</span>
        </label>
      </div>
    </div>

    <div class="wo-schedule-extra">
      <div class="wo-schedule-extra__actions">
        <button
          type="button"
          class="wo-action-button wo-action-button--ghost"
          :disabled="!canSaveSchedule"
          @click="submitSchedule"
        >
          {{ loading ? 'Saving schedule...' : 'Save schedule' }}
        </button>
      </div>
    </div>
  </article>
</template>
